import React from "react";
import FormAttributeDraggableCreator from './components/FormAttributeDraggableCreator';
import FADraggableEditor from './components/FADraggableEditor';
import FormAttributeApiService from './services/FormAttributeApiService';
import Sortable from 'react-sortablejs';
import APP_CONSTANTS from '../shared/constants/app_constants';

export default class KeenformEditor extends React.Component{
  
  constructor(props){
    super(props);
    let formAttributes = props.keenform.form_attributes || [];
    // add deleted prop to each attribute to allow for removal
    formAttributes.forEach( (fa) => {
      fa.deleted = false;
      fa.new = false;
    });
    // set state for component
    this.state = {
      formAttributes: formAttributes.filter((fa) => fa?.form_attribute_type != APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.INLINE_STYLE),
      askForSave: false,
      draggedItem: undefined
    };
    this.onDragFATypeStart                = this.onDragFATypeStart.bind(this);
    this.onDragFATypeEnd                  = this.onDragFATypeEnd.bind(this);
    this.deleteFormAttribute              = this.deleteFormAttribute.bind(this);
    this.addFormAttributeOnClickCreator   = this.addFormAttributeOnClickCreator.bind(this);
    this.faApiService = new FormAttributeApiService(props.rails_authenticity_token);
  }

  componentDidMount(){
    const hashLink = document.location.hash;
    if ( hashLink ){
      const hashRef = hashLink.replace("#","");
      this.scrollToRef(hashRef);
    }
  }

  // TODO: change name to addNewFormAttributeToEditor
  addFormAttributeToEditorOnFATypeDrop = (faType, orderOfItems) => {
    // based on orderOfItems find index of newly created item, create new Form Attribute
    const regexStartWithUnderscore = /^__[0-9]/; //use this regex to locate item dropped
    const indexOfDroppedItem = orderOfItems.findIndex( fa => regexStartWithUnderscore.test(fa));
    this.addFormAttributeToEditor(faType.display_type, indexOfDroppedItem, "addOnDrag");
    // TODO: reindex position of other form attribute
  }

  addFormAttributeOnClickCreator = (faType) => {
    if ( this.formAttributeLimitReached() ){
      alert('You have reached the maximum quantity of form attributes - you can UPGRADE your plan to add more');
    } else {
      const indexOfNewFA = this.state.formAttributes.length;
      //TODO: handle deleted form attribute
      this.addFormAttributeToEditor( faType, indexOfNewFA, "addOnClick");
    }
  }

  addFormAttributeToEditor = (faType, arrayIndex, addMethod) => {
    const self = this;
    let newFormAttribute = this.faApiService.getNewFormAttributeObjectWithDefaults(this.props.keenform.id, faType);
    newFormAttribute.position = arrayIndex + 1;
    this.insertPlaceholderIntoEditor(faType, arrayIndex, addMethod, () => {
      this.faApiService.createFormAttributeWithDefaults(self.props.keenform.id, newFormAttribute)
      .then( (newFormAttribute) => {
        if (newFormAttribute && newFormAttribute.id){
          self.insertNewFormAttributeIntoUI(newFormAttribute, addMethod);
        } else {
          console.error('adding form attribute FAILED');
          const updatedFormAttributeState = this.state.formAttributes.filter(fa => fa.id !== -1);
          this.setState({
            formAttributes: updatedFormAttributeState
          });
        }
      })
      .catch ( (error) => {
        console.error('error in saving form attribute');
        console.log(error);
      });
    });
  }

  afterAddedFAAction = (addMethod) => {
    let newFA;
    const allFAs = this.state.formAttributes.map((fa) => {
      if (fa.new === true){
        newFA = fa;
      }
      return {...fa, new: false};
    });
    this.setState({
      formAttributes: allFAs
    });
    const reorderedItems = allFAs.map((fa) =>{
      return fa.uuid;
    });
    this.reorderFormAttributes(reorderedItems);
    //TODO: conditionally scroll to newly added FA on CLICK ADD
    if (addMethod === "addOnClick"){
      this.scrollToRef(newFA.uuid);
    }
  }

  // TODO: disabled because not in use
  formAttributeLimitReached = () => {
    if (!this.props.plan_limits.form_attribute_limit){
      return false;
    }
    const formAttributeCount = ( (this.state.formAttributes
      .filter(fa => fa.deleted === false)).length);
    const formAttributeLimitReached = formAttributeCount >= this.props.plan_limits.form_attribute_limit;
    return formAttributeLimitReached;
  }

  deleteFormAttribute = (formAttributeId) => {
    let self = this;
    let deleteFA = confirm("Are you certain you want to delete this form attribute");
    if (deleteFA){
      let faToBeDeleted;
      let updatedFormAttrArray = this.state.formAttributes.map( (fa) => {
        if (fa.id === formAttributeId){
          fa.deleted = true;
          fa.position = undefined;
          faToBeDeleted = fa;
        }
        return fa;
      });

      self.faApiService.deleteFormAttribute(faToBeDeleted.id, faToBeDeleted.keenform_id) //(self.props.keenform.id, newFormAttribute)
        .then( (response) => {
          // TODO mark this fa as deleted
          if (response && response.success){
            this.setState({
              formAttributes: updatedFormAttrArray
            }, () => {
              this.resetOrderOfFAPerState();
            });
          } else {
            //TODO - check error messages to show why delete failed
            alert('An error occurred while deleting this form attribute');
          }
        })
        .catch ( (error) => {
          console.error(error);
          alert('An error occurred while deleting this form attribute');
        });
    }
  }

  dragOverEvent = (e) => {
    e.preventDefault();
  }

  getIndexOfFormAttribute = (form_attribute_id) => {
    for(let i=0; i<this.state.formAttributes.length; i++){
      if (this.state.formAttributes[i].id === form_attribute_id){
        return i;
      }
    }
    return null;
  }

  getLinkToDashboard = () => {
    return `/dashboard/keenforms/${this.props.keenform.id}`;
  }

  getPlaceholderFormAttribute = (displayType, method = "addOnDrag") => {
    return {
      display_type: displayType,
      id: -1, //TODO should we make this more explicit? -1 or something else?
      uuid: '__placeholder__',
      options: [],
      deleted: false,
      new: true,
      addMethod: method
    };
  }

  insertNewFormAttributeIntoUI = (newFormAttribute, addMethod = "addOnDrag") => {
    const self = this;
    let newFA = Object.assign({
      deleted: false, 
      new: true,
      addMethod: addMethod
    }, newFormAttribute); //add new stuff to fa
    //TODO: should we remove all deleted form attributes from array?
    let newFormAttributesArray = [].concat(this.state.formAttributes).filter(fa => !fa.deleted );
    // replace placeholder element with newFA
    const indexOfPlaceholder = newFormAttributesArray.findIndex(fa => fa.id === -1);
    newFormAttributesArray[indexOfPlaceholder] = newFA;
    
    //now update positions of all the form attributes
    newFormAttributesArray.forEach((fa, index) => {
      fa.position = index+1;
    });

    //now render to screen the updated form attributes
    this.setState({
      formAttributes: newFormAttributesArray
    }, () => {
      setTimeout(()=>{
        self.afterAddedFAAction(addMethod);
      }, 500);
    });
  }

  insertPlaceholderIntoEditor = (faType, arrayIndex, addMethod, callback) => {
    let formAttributeState = [].concat(this.state.formAttributes);
    let newFA = this.getPlaceholderFormAttribute(faType, addMethod);
    formAttributeState.splice(arrayIndex, 0, newFA); // why splice?
    this.setState({formAttributes: formAttributeState}, callback );
  }

  // on sortable editor change event
  onDropFAEditorEvent = (order, sortable, event) => {
    if (this.state.draggedItem){
      // TODO: insert new placeholder DOM element
      const faTypeDomEl = this.state.draggedItem;
      const faTypeData = faTypeDomEl.getAttribute("data-fa-object");
      this.setState({draggedItem: undefined});
      this.addFormAttributeToEditorOnFATypeDrop(JSON.parse(faTypeData), order);
    } else{
      this.reorderFormAttributes( order );
    }
  }

  onDragFATypeStart = (event) => {
    this.setState({
      formAttributes: this.state.formAttributes.filter(fa => !fa.deleted ),
      draggedItem: event.item
    });
  }

  onDragFATypeEnd = (event) => {
    this.setState({ draggedItem: undefined});
  }

  // TODO: check if this is necessary
  purgeDeletedFA = () => {
    const updatedFormAttributes = this.state.formAttributes.filter(fa => !fa.deleted);
    this.setState({
      formAttributes: updatedFormAttributes
    })
  }

  //function receives order of uuids of form attributes, function must sort fa based on order
  reorderFormAttributes = (items) => { //TODO: should we rename this?
    let updatedFormAttribute = [];
    //get new array with order of items based on UI
    let faIndex = 1;
    items.forEach((uuid) => {
      const thisFormAttribute = this.state.formAttributes.find( fa => fa.uuid == uuid);
      if (thisFormAttribute?.deleted !== true){ // TODO: this is in desperate need of refactoring
        thisFormAttribute.position = faIndex;
        faIndex++;
      } else {
        thisFormAttribute.position = undefined;
      }
      updatedFormAttribute.push(thisFormAttribute);
    });
    const updatedFAPositions = updatedFormAttribute.filter(fa => !fa.deleted )
    this.setState({
      formAttributes: updatedFormAttribute
    });
    this.faApiService.reorderFormAttributes(this.props.keenform.id, updatedFAPositions)
      .then( (response) => {
        console.log('items reordered', response);
        //TODO: do something with the response?
        return response;
      });
  }

  resetOrderOfFAPerState = () => {
    const orderOfItems = this.state.formAttributes
      .map(fa => fa.uuid);
    this.reorderFormAttributes(orderOfItems);
  }

  removeFAFromUI = (deletedFormAttribute) => {
    const updatedFormAttributeArray = this.state.formAttributes.filter( (fa) => {
      return fa.id !== deletedFormAttribute.id;
    });
    this.setState({
      formAttributes: updatedFormAttributeArray
    });
  }

  scrollToRef = (ref) => {
    const refDom = document.getElementById(ref);
    if (refDom){
      refDom.scrollIntoView();
    }
  }
  
  render() {
    const self = this;
    // const formAttributeCount = ( (this.state.formAttributes
    //   .filter(fa => fa.deleted === false)).length);
    const formAttributeLimitReached = this.formAttributeLimitReached();
    const formAttributeTypes = this.props.form_attribute_display_types
      .filter(type => type !== APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.INLINE_STYLE )
      .map((type, index) => {
      return (
        <FormAttributeDraggableCreator 
          display_type={type}
          draggable_type="creator"
          disableAdd={formAttributeLimitReached}
          onClickAdd={this.addFormAttributeOnClickCreator}
          index={index}
          key={index}
        />);
      });
    const sortableFormAttributeEditors = this.state.formAttributes.map( (formAttribute, index) => {
      if (formAttribute.form_attribute_type === APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.INLINE_STYLE) {
        return undefined;
      } else {
        return (<FADraggableEditor
          key={index}
          index={index}
          formAttribute={formAttribute}
          addMethod={formAttribute.addMethod}
          keenform={this.props.keenform}
          draggable_type="editor"
          rails_authenticity_token={this.props.rails_authenticity_token}
          onDeleteFormAttribute={this.deleteFormAttribute} />);
      }
    }).filter(fa => fa != undefined);
    return (
      <div>
        <div className="row">
          { formAttributeLimitReached
            ? <div className="col-12">
                <div className="alert alert-warning" role="alert">
                You have reached this user plan maximum quantity of form attributes with your selected plan: {this.props.plan_limits.form_attribute_limit}
                </div>
              </div>
            : undefined
          }
          <div className="col-md-3">
            <div className="sidebar-item">
              <div className="sticky-sidebar">
                <div 
                  id="fa-display-type-library" 
                  className={formAttributeLimitReached ? 'disable-add-fa-void' : ''}>
                  <h6 className="text-center">Form Attribute Types</h6>
                  <Sortable
                    options={{
                      animation: 150,
                      sort: false,
                      group: {
                        name: 'keenformEditor',
                        pull: 'clone',
                        put: false
                      },
                      ghostClass: "sortable-ghost",
                      onStart: function (evt) {
                        self.onDragFATypeStart(evt);
                      },
                      onEnd: function (evt) {
                        self.onDragFATypeEnd(evt);
                      }
                    }}
                    >
                    {formAttributeTypes}
                  </Sortable>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-9">
            <div id="keenform-dnd-editor"
              onDragOver={this.dragOverEvent}>
                <Sortable
                  options={{
                    animation: 150,
                    group: {
                      name: 'keenformEditor',
                      pull: false,
                      put: true
                    },
                    onStart: function (evt) {
                      self.purgeDeletedFA()
                    },
                    handle: ".drag-handle"
                  }}
                  onChange={(order, sortable, event) => {
                    if (formAttributeLimitReached){
                      alert('You have reached the maximum quantity of form attributes - you can UPGRADE your plan to add more');
                    } else {
                      this.onDropFAEditorEvent(order, sortable, event);
                    }
                  }}>
                  { this.state.formAttributes.filter(fa => fa.deleted === false).length === 0 ? 
                  <div id="no-form-attributes-placeholder">Drag and Drop elements here</div> : undefined}
                  { sortableFormAttributeEditors }
                </Sortable>

            </div>
            <div>
              <a 
                href={this.getLinkToDashboard()}
                className="btn btn-default btn-round float-right">
                  <i className='fas fa-chevron-left'></i> Back to Dashboard
              </a>
            </div>
          </div>
        </div>
      </div>);
  }
}
